module.exports = __webpack_public_path__ + "img/F0D504_FBFAD3_B98609_CDA204-256px.420624b4.png";